import Api from '../Api'

export interface IUrlRedirector {
  id: number
  from: string
  to: string
  active: boolean
  user: {
    id: number
    name: string
  }
  created_at: string
}

export interface ICreateUpdateUrlRedirectorPayload {
  from: string
  to: string
}

export interface IListResponse {
  data: IUrlRedirector[]
  recordsTotal: number
  recordsFiltered: number
}

export interface IGetUrlRedirectorResponse {
  id: number
  from: string
  to: string
  active: boolean
  created_by: {
    id: number
    name: string
  }
  created_at: string
}

export class UrlRedirectorService {
  async list(search?: string, page?: number, pageSize?: number): Promise<IListResponse> {
    const params = {
      search: search || '',
      page: page || 1, // Default to page 1 if not provided
      page_size: pageSize || 25 // Default to 10 items per page if not provided,
    }
    const { data } = await Api.get('/url-redirectors', { params })
    return data
  }

  async get(id: number): Promise<IGetUrlRedirectorResponse> {
    const { data } = await Api.get(`/url-redirectors/${id}`)
    return data
  }

  async delete(id: number): Promise<void> {
    await Api.delete(`/url-redirectors/${id}`)
  }

  async create(payload: ICreateUpdateUrlRedirectorPayload): Promise<IUrlRedirector> {
    const { data } = await Api.post('/url-redirectors', payload)
    return data
  }

  async update(id: number, payload: ICreateUpdateUrlRedirectorPayload): Promise<IUrlRedirector> {
    const { data } = await Api.put(`/url-redirectors/${id}`, payload)
    return data
  }

  async updateActive(id: number, active: boolean): Promise<IUrlRedirector> {
    const { data } = await Api.put(`/url-redirectors/${id}`, { active })
    return data
  }
}
